/**
 * 帮助文档页接口
 * 路径与原有 jQuery 版本保持一致，baseURL 由 request 统一配置
 */
import request from "@/utils/request";

/** 根据软件别名获取菜单树数据 */
export function getSoftwareByAlias(alias, params = {}) {
  return request({
    url: `/client/software/softwareSelectByAlias/${alias}`,
    method: "get",
    params: {
      alias: params.alias || alias,
      language: params.language || "zh",
      version: params.version || "",
    },
  });
}

/** 根据菜单节点 id 获取文档详情 */
export function getSoftwareDetail(id, softwareId) {
  return request({
    url: `/client/softwareDetail/clientSoftwareDetailSelectById/${id}`,
    method: "get",
    params: {
      softwareId,
    },
  });
}

/** 帮助文档关键词搜索（分页） */
export function helpSearch(params) {
  return request({
    url: "/client/software/helpSearch",
    method: "get",
    params,
  });
}
